const LessonUtils = {
  // TODO @danny #domainlogic
  groupChunks(chunks) {
    const groups = [];
    let group = [];
    chunks.forEach((chunk, i) => {
      group.push(chunk);
      const next = chunks.get(i + 1);
      if (!next || !next.get('group_with_last')) {
        groups.push(group);
        group = [];
      }
    });
    return groups;
  },
};

export default LessonUtils;
